import randomstring from 'randomstring';
import policyVersions from './policyVersions';

export const BEST_URL = process.env.BEST_URL;
export const CLASSTING_ACCOUNTS_URL = process.env.CLASSTING_ACCOUNTS_URL;
export const CLASSTING_OIDC_CLIENT_ID = process.env.CLASSTING_OIDC_CLIENT_ID;
export const CLASSTING_REDIRECT_URI = `${window.location.origin}/oauth_callback/classting`;
export const CLASSTING_CLIENT_ID = process.env.CLASSTING_CLIENT_ID;
export const CLASSTING_AUTH_URL = process.env.CLASSTING_AUTH_URL;
export const CLASSTING_URL = process.env.CLASSTING_URL;
export const MINERVA_API_URL = process.env.MINERVA_API_URL;
export const CT_API_URL = process.env.CT_API_URL;
export const AI_WEB_URL = process.env.AI_WEB_URL;
export const CT_PERF_URL = process.env.CT_PERF_URL;
export const CT_VIEWER_URL = process.env.CT_VIEWER_URL;
export const CL_EVENTS_URL = process.env.CL_EVENTS_URL;
export const CL_EVENTS_API_URL = process.env.CL_EVENTS_API_URL;
export const NEW_CLASS_BASE_URL = process.env.NEW_CLASS_BASE_URL;
export const NEW_CLASS_BACKEND_BASE_URL = process.env.NEW_CLASS_BACKEND_BASE_URL;
export const AWS_CF_URL = process.env.AWS_CF_URL;
export const LOG_URL = process.env.LOG_URL;
export const LOG_BASE_URL = process.env.LOG_BASE_URL;
export const VIDEO_LAMBDA_URL = process.env.VIDEO_LAMBDA_URL;
export const FEATURED_PUBLISHER_ID = process.env.FEATURED_PUBLISHER_ID;
export const GOOGLE_FORMS = process.env.GOOGLE_FORMS;
export const SLACK_CONFIG = process.env.SLACK_CONFIG;
export const CONTENT_REPORTS_CONFIG = process.env.CONTENT_REPORTS_CONFIG;
export const GA_ID = process.env.GA_ID;
export const CLASSTING_FULL_AUTH_URL = [
  `${CLASSTING_ACCOUNTS_URL}/oidc/auth`,
  `?client_id=${CLASSTING_OIDC_CLIENT_ID}`,
  '&response_type=id_token+token',
  '&scope=openid+email+profile',
  `&nonce=${randomstring.generate(10)}`,
  `&redirect_uri=${CLASSTING_REDIRECT_URI}`,
].join('');
export const VERSION = process.env.VERSION;
export const AUTH_TOKEN_KEY = 'auth_token';
export const USER_TUTORIAL_KEY = 'user_tutorial';
export const USER_CL_EVENTS_KEY = 'cl_events';
export const CURRENT_USER_KEY = 'current_user';
export const POLICY_VERSIONS = policyVersions;



// WEBPACK FOOTER //
// ./src/config/index.js